// extracted by mini-css-extract-plugin
export var dropdownIcon = "_sm-6";
export var imgContainer = "_sm-3";
export var menuIcon = "_sm-5";
export var pillWrapper = "_sm-2";
export var pillsContainer = "_sm-1";
export var subscriptionCard = "_sm-0";
export var subscriptionLogo = "_sm-4";